import React from "react";

export function IconPlaceholder() {
    return <div style={{ width: 18, height: 18 }} aria-hidden/>;
}